import { Serialisers } from './serialisers';
/**
 * @public
 */
export class ExpressionBuilder {
    constructor(opts) {
        this.serialiser = Serialisers.EQ;
        this.build = () => {
            if (!this.field) {
                throw new Error(`Missing required param 'field'`);
            }
            if (this.value === undefined) {
                throw new Error(`Missing required param 'value'`);
            }
            if (!this.serialiser) {
                throw new Error(`Missing required param 'serialise'`);
            }
            return {
                field: this.field,
                value: this.value,
                serialiser: this.serialiser,
                params: this.params,
                valueGetter: this.valueGetter,
                group: this.group,
            };
        };
        if (opts) {
            this.field = opts.field;
            this.value = opts.value;
            this.serialiser = opts.serialiser;
            this.params = opts.params;
            this.valueGetter = opts.valueGetter;
            this.group = opts.group;
        }
    }
    withField(field) {
        this.field = field;
        return this;
    }
    withValue(value) {
        this.value = value;
        return this;
    }
    withSerialiser(serialiser) {
        this.serialiser = serialiser;
        return this;
    }
    withParams(params) {
        this.params = params;
        return this;
    }
    withValueGetter(valueGetter) {
        this.valueGetter = valueGetter;
        return this;
    }
    withGroup(group) {
        this.group = group;
        return this;
    }
}
